export default __webpack_public_path__ + "static/media/icon-close.7ab0b2f2.svg";